const datadogKeys = {
  appId: 'd7fff791-3fd6-4634-abe8-fcb8e0066ff8',
  clientToken: 'pub5dbdd6f9af4f438e828d5c486f48643c',
  service: 'outside-learn',
  site: 'datadoghq.com',
  forwardErrorsToLogs: true
};

module.exports = datadogKeys;
